import React, { useEffect, useState } from "react";
import { profileimage } from "../../Assets/images/ImagesIndex";

import { logOut } from "../../Redux/Slices/Pages/Auth/LoginSlice";
import { useDispatch} from "react-redux";
import { useNavigate } from "react-router-dom";
import ProfessionalAccount from "./Components/professionalAccount/ProfessionalAccount";
import Booking from "./Components/Professionalbooking/Booking";
import Zapprofessional from "./Components/ZAP BOOKING/Zapprofessional";
import Stuff from "./Components/MY STUFF/STuff";
import Togglebar from "../../Components/Togglebar/Togglebar";

const Professional = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState("zapp");
  console.log(activeSection);

  console.log("✅ Stored Token:", sessionStorage.getItem("token"));

  const logoutHandler = () => {
        console.log("logout handler")

    dispatch(logOut());
    console.log("logout handler")
    navigate("/login"); // or "/"
  };

  return (
    <div className="main-section w-full flex h-screen  space-x-2 p-5">
      <div className="left-section w-3/12 mx-2  my-5 ">
        <div className="w-full flex items-center justify-start gap-1 bg-white rounded-md h-24 mb-2">
          <div className="w-20   p-3">
            <img
              src={profileimage}
              className="rounded-full w-8 h-8 object-contain"
              alt="Profile"
            />
          </div>

          <div>
            <h1 className="text-sm text-gray-600">Hello</h1>
            <p className="font-semibold text-gray-800">ashfak</p>
          </div>
        </div>
        <div className="flex flex-col ">
          <div className="w-full mt-3 text-sm text-gray-700 bg-white text-start p-4 space-y-8 rounded-md">
            <p
              onClick={() => setActiveSection("zapp")}
              className={`mb-3 cursor-pointer mt-5 ${
                activeSection === "zapp" ? "text-blue-600 " : "text-gray-500"
              }`}
            >
              {" "}
              ZAPprofessional booking{" "}
            </p>

            <p
              onClick={() => setActiveSection("booking")}
              className={`mb-3 cursor-pointer ${
                activeSection === "booking" ? "text-blue-600 " : "text-gray-500"
              }`}
            >
              professional booking
            </p>
            <p
              onClick={() => setActiveSection("profsettings")}
              className={`mb-3 cursor-pointer ${
                activeSection === "profsettings"
                  ? "text-blue-600 "
                  : "text-gray-500"
              }`}
            >
              prof-account setting
            </p>
            <p
              onClick={() => setActiveSection("sttuff")}
              className={`mb-2 cursor-pointer ${
                activeSection === "sttuff" ? "text-blue-600 " : "text-gray-500"
              }`}
            >
              MYSTUFF
            </p>
          </div>
        </div>
        {/* <div className="w-full rounded-md bg-white py-2 my-5 ">
          <button className="bg-blue-900 rounded text-white text-sm p-2 w-6/12 mx-auto">
            SWITCH TO ZAP PROFESSIONAL
          </button> 


        </div>  */}
        <div className="w-full bg-white py-2 my-5 mx-auto">
          <Togglebar />
        </div>

        <div className="w-full bg-white text-center p-3 mt-2 rounded-md">
          <button className="text-red-500" onClick={logoutHandler}>
            LOGOUT
          </button>
        </div>
      </div>

      <div className="right-section w-9/12 my-5 rounded-md ">
        <div className="flex  space-x-5 right-section-heading  mb-5  rounded-md">
          <div className="bg-white w-3/12 rounded-md p-3 h-24 ">
            <h1 className="">profes</h1>
          </div>
          <div className="bg-white w-3/12 rounded-md p-3 h-24 ">
            <h1 className="">profes</h1>
          </div>
          <div className="bg-white w-3/12 rounded-md p-3 h-24 ">
            <h1 className="">profes</h1>
          </div>
          <div className="bg-white w-3/12 rounded-md p-3 h-24 ">
            <h1 className="">profes</h1>
          </div>
        </div>

        <div className="bg-white mt-5 ">
          {activeSection === "zapp" && <Zapprofessional />}
          {activeSection === "booking" && <Booking />}
          {activeSection === "profsettings" && <ProfessionalAccount />}
          {activeSection === "sttuff" && <Stuff />}
        </div>
      </div>
    </div>
  );
};

export default Professional;
